const UNAUTHORIZED_ERROR_MSG = 'Unauthorized user'
export { UNAUTHORIZED_ERROR_MSG }
